/**
 * SIMPS Drink Lab — flavorColors.js
 * Maps flavour keys to an accent colour used only on the result screen
 * (top accent stripe + flavour name), per spec §41. All other UI chrome
 * (buttons, body text, headings) continues to use the theme's own color
 * and font variables — this file adds one accent colour on top.
 */
window.DrinkLab = window.DrinkLab || {};

window.DrinkLab.FLAVOR_COLORS = {
  passionfruit: '#F2B705', guava: '#E8637A', prickly_pear: '#D6336C', watermelon: '#E4384C',
  blue_raspberry: '#2F6FED', raspberry: '#C22355', blackberry: '#3B2452', strawberry: '#E0364F',
  blueberry: '#3E4C8A', huckleberry: '#5B2A6E', mango: '#F4A020', pineapple: '#F2C230',
  peach: '#F4926A', pomegranate: '#B3123A', grapefruit: '#F0716B', coconut: '#C9BFA8',
  lavender: '#9E7FC7', elderflower: '#EDE6D6', hibiscus: '#C2185B', rosemary: '#5C7A56',
  vanilla: '#EAD9A0', french_vanilla: '#EFDFAE', hazelnut: '#8A5A34', caramel: '#B5651D',
  salted_caramel: '#A9682A', toasted_marshmallow: '#F2E6D0', shortbread: '#D9B478',
  english_toffee: '#8C5A2E', brown_sugar_cinnamon: '#8B4A2B', macadamia_nut: '#D8C2A0',
  pistachio: '#93A66B', pumpkin_spice: '#C6641C', simple_syrup: '#EDEDED', lemon_sour: '#F4E04D',
  margarita_mix: '#CFE6A0'
};

window.DrinkLab.CLASSIC_SODA_COLORS = {
  root_beer: '#3D2314', cola: '#2B1B12', ginger_ale: '#E8D77A', ginger_beer: '#D9A441',
  cream_soda: '#F2E6C8', orange_soda: '#F2941E', lemon_lime: '#B6D93C', black_cherry: '#5B1A2B',
  spiced_apple: '#C05A2E', tonic: '#DDE6DD', motley_dew: '#C7D92E', dr_feelgood: '#E0A030',
  iced_tea: '#A9732F', fruit_punch: '#D9294F', lemonade: '#F4E04D'
};

window.DrinkLab.DEFAULT_FLAVOR_COLOR = 'var(--color-global)';
